<template>
<div class="chapter">
<div class="inner_page">
<p class="P_RaggedRight" id="auto_bookmark_toc_1"><span style=" font-weight: bold; font-size: 1.17em;">“You okay, man? That was a huge sigh.” Dirk gave him a sympathetic look.</span></p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“No. No, I’m really not.” Logan opened his mouth to spill everything when the newlyweds, Aiden and Dev, walked into the shop. “My godson!”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Dev handed Dylan over without a word, and Logan took him happily. He adored his godson.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Aiden studied Logan. “What’s wrong?”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“What do you mean?” He went for innocent.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Aiden raised a single eyebrow, the annoying ass. “Something’s wrong. Spill.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">“I….” Logan took his coffee and sat, baby Dylan in his arms giving him comfort. “I’m going to foster a set of triplets. They’re two days old. I’m supposed to pick them up Monday.”</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">There. He’d said it out loud. He’d gone through the foster-parent classes without telling anyone because he knew he could do this. He could.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Maybe.</p>
<p class="P_RaggedRight"> </p>
<p class="P_RaggedRight">Oh God.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?6111ca2a